<template>
<svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00002 9.00065C5.88669 9.00065 4.16669 7.28065 4.16669 5.16732C4.16669 3.05398 5.88669 1.33398 8.00002 1.33398C10.1134 1.33398 11.8334 3.05398 11.8334 5.16732C11.8334 7.28065 10.1134 9.00065 8.00002 9.00065ZM8.00002 2.33398C6.44002 2.33398 5.16669 3.60732 5.16669 5.16732C5.16669 6.72732 6.44002 8.00065 8.00002 8.00065C9.56002 8.00065 10.8334 6.72732 10.8334 5.16732C10.8334 3.60732 9.56002 2.33398 8.00002 2.33398Z" fill="currentColor"/>
<path d="M13.7268 15.6667C13.4534 15.6667 13.2268 15.44 13.2268 15.1667C13.2268 12.8667 10.8801 11 8.0001 11C5.1201 11 2.77344 12.8667 2.77344 15.1667C2.77344 15.44 2.54677 15.6667 2.27344 15.6667C2.0001 15.6667 1.77344 15.44 1.77344 15.1667C1.77344 12.32 4.56677 10 8.0001 10C11.4334 10 14.2268 12.32 14.2268 15.1667C14.2268 15.44 14.0001 15.6667 13.7268 15.6667Z" fill="currentColor"/>
</svg>

</template>

<script>
export default {
    name: 'InvitationRequestIcon',

    data() {
        return {

        }
    },
    computed: {
    },
};
</script>